import { IBaselineBurstResponse } from '@kcftech/prometheustypescriptapiclient';
import { skipToken, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export const queryKey = 'baseline-burst-data';

export function useBaselineBurstData(
    indicatorId: string | undefined,
    queryOptions?: Omit<
        UseQueryOptions<IBaselineBurstResponse | undefined>,
        'queryKey' | 'queryFn'
    >
) {
    return useQuery({
        queryKey: [queryKey, indicatorId],

        queryFn:
            indicatorId !== undefined
                ? () => sdClient.getIndicatorBaselineBurst({ indicatorId })
                : skipToken,

        ...queryOptions,
    });
}

export function invalidateBaselineBurstData(indicatorId?: string) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, indicatorId],
    });
}
